import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import "./header.css";
import KyyLogo from "../../assets/kyyLogoBlack.svg";

const Header = () => {
    const location = useLocation();
    const isHome = location.pathname === '/';

    /*=============== Change Background Header ===============*/
    window.addEventListener("scroll", function () {
        const header = document.querySelector(".header");
        if (header) {
            if (this.scrollY >= 80) header.classList.add("scroll-header");
            else header.classList.remove("scroll-header");
        }
    });

    /*=============== Toggle Menu ===============*/
    const [Toggle, showMenu] = useState(false);

    const renderLink = (sectionId, iconClass, label) => {
        if (isHome) {
            return (
                <a href={`#${sectionId}`} className="nav-link">
                    <i className={`uil ${iconClass} nav-icon`}></i>
                    {label}
                </a>
            );
        } else {
            return (
                <Link to={`/?section=${sectionId}`} className="nav-link">
                    <i className={`uil ${iconClass} nav-icon`}></i>
                    {label}
                </Link>
            );
        }
    };

    return(
        <header className="header">
            <nav className="nav container">
                {isHome ? (
                    <a href="#about" className="nav-logo">
                        <img src={KyyLogo} alt="Kyy Logo" className="nav-logo" />
                    </a>
                ) : (
                    <Link to="/" className="nav-logo">
                        <img src={KyyLogo} alt="Kyy Logo" className="nav-logo" />
                    </Link>
                )}

                <div className={Toggle ? "nav-menu show-menu" : "nav-menu"}>
                    <ul className="nav-list grid">
                        <li className="nav-item">
                            {renderLink("about", "uil-user", "About")}
                        </li>

                        <li className="nav-item">
                            {renderLink("skills", "uil-file", "Skills")}
                        </li>

                        <li className="nav-item">
                            {renderLink("services", "uil-briefcase", "Services")}
                        </li>

                        <li className="nav-item">
                            {renderLink("portfolio", "uil-scenery", "Portfolio")}
                        </li>

                        <li className="nav-item">
                            {renderLink("contact", "uil-message", "Contact")}
                        </li>
                    </ul>

                    <i class="uil uil-times nav-close" onClick={() => showMenu(!Toggle)}></i>
                </div>

                <div className="nav-toggle" onClick={() => showMenu(!Toggle)}>
                    <i class="uil uil-apps"></i>
                </div>
            </nav>
        </header>
    )
}

export default Header;
